import { Permission } from '@models/Permission'
import { hasPermission } from '@services/PermissionService'

export enum MainMapTypes {
  METEO,
  INCENDIOS
}

export namespace MainMapTypes {
  export function getName(type: MainMapTypes) {
    return {
      [MainMapTypes.METEO]: 'Meteorologia',
      [MainMapTypes.INCENDIOS]: 'Incendios'
    }[type]
  }

  export function getIfPermision(permission: Permission, type: MainMapTypes) {
    return hasPermission(permission) ? [type] : []
  }

  export function getList() {
    return [
      ...getIfPermision(Permission.ACCESO_METEO, MainMapTypes.METEO),
      ...getIfPermision(Permission.ACCESO_INCENDIOS, MainMapTypes.INCENDIOS)
    ]
  }
}
